import { useEffect, useMemo, useRef } from "react";
import ItemGrid from "../components/catalog/ItemGrid";
import MarketIntro from "../components/catalog/MarketIntro";
import BrowseFilters from "../components/filters/BrowseFilters";
import { filterItems, sizesFor } from "../data/catalog";
import useBrowseState from "../hooks/useBrowseState";

// Brief fade (see body.v133BrowseChanging in the styles) when the visible category changes.
function useBrowseTransition(key) {
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return undefined;
    }
    document.body.classList.add("v133BrowseChanging");
    const timer = setTimeout(() => document.body.classList.remove("v133BrowseChanging"), 230);
    const intro = document.querySelector("#v129BrowseContent .marketIntro");
    const header = document.querySelector("header.top");
    if (intro) {
      const top = window.scrollY + intro.getBoundingClientRect().top - (header?.offsetHeight || 0) - 6;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }
    return () => {
      clearTimeout(timer);
      document.body.classList.remove("v133BrowseChanging");
    };
  }, [key]);
}

export default function HomePage() {
  const { department, subcategory, size, sort, latest } = useBrowseState();
  const items = useMemo(
    () => filterItems({ department, subcategory, size, sort, latest }),
    [department, subcategory, size, sort, latest],
  );

  useBrowseTransition(`${department}|${subcategory}|${size}|${latest}`);

  let emptyMessage = `No products available in ${subcategory !== "All" ? subcategory : department !== "All" ? department : "this category"} right now.`;
  let emptyClassName = "empty";
  if (size !== "All" && sizesFor(department, subcategory)) {
    emptyMessage = "No stock available in this size.";
    emptyClassName = "noStockSize";
  }

  return (
    <>
      <section id="v129BrowseContent">
        <MarketIntro />
        <BrowseFilters count={items.length} />
      </section>
      {process.env.REACT_APP_INVENTORY_SOURCE === "facebook" && window.inventoryLoadError && (
        <div role="alert" style={{ padding: "32px 0" }}>
          <p>{window.inventoryLoadError}</p>
          <button type="button" onClick={() => window.location.reload()}>Try again</button>{" "}
          <a href="https://www.facebook.com/marketplace/profile/61567154155885/" target="_blank" rel="noopener noreferrer">View Facebook listings</a>
        </div>
      )}
      <ItemGrid items={items} emptyMessage={emptyMessage} emptyClassName={emptyClassName} />
    </>
  );
}
